module.exports = __webpack_public_path__ + "static/media/profile.ae4c68f7.png";